import { useUserContext } from "../../context/UserContext";
import { useCartContext } from "../../context/CartContext";
import { usePublicCatalog } from "../../context/PublicCatalogContext";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import type { ReactElement } from "react";
import { log } from "../../utils/logger";

interface RequireCartProps {
  children: ReactElement;
}

const RequireCart = ({ children }: RequireCartProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sp] = useSearchParams();
  const payId = sp.get("payId");

  const { cartData, cartLoaded } = useCartContext();
  const { loggedIn } = useUserContext();
  const { isPublicView } = usePublicCatalog();

  const isOrderConfirmation = location.pathname.startsWith("/order-confirmation");
  const isOrderSettings = location.pathname.startsWith("/order-settings");
  const isPublicCatalog = location.pathname.startsWith("/public-catalog");

  // Treat cart as "valid" only if it looks real (id) and is active (if backend provides it)
  const cartOk =
    Boolean(cartData?.id) &&
    (cartData?.cart_active === undefined ? true : Boolean(cartData.cart_active));

  useEffect(() => {
    if (isPublicView || isPublicCatalog) return;
    if (!loggedIn) return;
    if (!cartLoaded) return; // Wait until cart fetch is really done
    if (isOrderConfirmation) return;
    if (payId) return;
    if (isOrderSettings) return; // Prevent redirect loop

    if (!cartOk) {
      /*
      log("[RequireCart redirect]", {
        path: location.pathname,
        loggedIn,
        cartLoaded,
        cartData,
        cartId: cartData?.id,
        cartActive: cartData?.cart_active,
      });
      */
      console.trace("[RequireCart redirect trace]");
      navigate("/order-settings", { replace: true, state: { from: location.pathname } });
    }
  }, [
    cartLoaded,
    cartOk,
    isOrderConfirmation,
    isOrderSettings,
    isPublicCatalog,
    isPublicView,
    loggedIn,
    navigate,
    location.pathname,
    payId,
  ]);

  return children;
};

export default RequireCart;
